class PaginationHandler extends HTMLElement {
  constructor () {
    super()
    this.isLoading = false
    this.observer = null
    this.setupInfiniteScroll()
    this.handleBfcache()
  }

  handleBfcache () {
    // Reset state when page is restored from bfcache (back/forward navigation)
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.isLoading = false
        // Re-check if we need to load more content
        if (this.observer) {
          const rect = this.getBoundingClientRect()
          const isInViewport = (
            rect.top >= -200 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 200
          )
          if (isInViewport) {
            this.loadMore()
          }
        }
      }
    })
  }

  setupInfiniteScroll() {
    const that = this

    // Use IntersectionObserver for infinite scroll
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !that.isLoading) {
          that.loadMore()
        }
      })
    }, {
      rootMargin: '200px' // Start loading 200px before reaching the element
    })

    this.observer.observe(this)
  }

  loadMore() {
    const that = this
    const totalPages = parseInt(document.querySelector('[data-total-pages]').value)
    const currentPage = parseInt(document.querySelector('[data-current-page]').value)

    // Already reached the bottom
    if (currentPage >= totalPages) {
      that.remove()
      return
    }

    // Prevent multiple simultaneous loads
    if (this.isLoading) return
    this.isLoading = true

    // Show spinner
    const spinner = document.querySelector('.pagination-spinner')
    if (spinner) spinner.style.display = 'block'

    const nextUrl = document
      .querySelector('[data-next-url]')
      .value.replace(/page=[0-9]+/, 'page=' + (currentPage + 1))

    const currentPageElement = document.querySelector('[data-current-page]')

    fetch(nextUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.text()
      })
      .then(function (responseHTML) {
        // Parse the response
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = responseHTML
        const items = tempDiv.querySelector('.collection-grid').innerHTML
        document
          .querySelector('.collection-grid')
          .insertAdjacentHTML('beforeend', items)

        // Initialize lazy loading for newly added images
        if (typeof window.initLazyImages === 'function') {
          window.initLazyImages()
        }

        // Re-apply collection search filter to newly loaded items
        if (typeof window.collectionSearchReapply === 'function') {
          window.collectionSearchReapply()
        }

        // Update current page
        const newPage = currentPage + 1
        currentPageElement.value = newPage

        // Check if we've reached the last page
        if (newPage >= totalPages) {
          that.remove()
        }
      })
      .catch(function (error) {
        console.error(error)
      })
      .finally(() => {
        if (spinner) spinner.style.display = 'none'
        that.isLoading = false

        // Re-check if we need to load more after products are appended
        // This handles the case where the pagination element is still visible
        setTimeout(() => {
          const totalPages = parseInt(document.querySelector('[data-total-pages]').value)
          const currentPage = parseInt(document.querySelector('[data-current-page]').value)

          // Only auto-load if not on last page and element is still in viewport
          if (currentPage < totalPages && that.observer) {
            const rect = that.getBoundingClientRect()
            const isInViewport = (
              rect.top >= -200 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 200
            )

            if (isInViewport && !that.isLoading) {
              that.loadMore()
            }
          }
        }, 100)
      })
  }
}

customElements.define('pagination-handler', PaginationHandler)
